import React, { FC, RefObject } from 'react'
import { Direction, REQUEST_CONFIGS_KEYS } from '@services/constants'
import TextInput from '../inputs/text.inputs'
import RadioInput from '../inputs/radio.input'
import { classes } from './__index.utils'
import { RadioList } from '@utils/request'
import MaskedTextInput from '../inputs/textWithValidation.inputs'
import * as utilsList from './__index.utils'

const Step1TypeDeDemande = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false
}) => {
	const {
		whatToDo,
		requestAs,
		companyName,
		representativeName,
		isSubjectToPiiaApproval,
		hasBeenSubjectToApproval,
		iaNumber,
		ecResolutionNumber
	} = formInputs

	const radioListWhatToDo: RadioList[] = utilsList.radioListWhatToDo(pageAssets)
	const radioListRequestAs: RadioList[] =
		utilsList.radioListRequestAs(pageAssets)
	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)

	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_type_de_demandes}
				</h4>
			)}

			{/* Question 1 */}
			<RadioInput
				name={whatToDo.name}
				label={whatToDo.label}
				value={whatToDo.value}
				list={radioListWhatToDo}
				direction={Direction.vertical}
				hasError={errors!.includes(whatToDo.name)}
				onChange={(value) => updateInput(whatToDo.name, value)}
				ref={whatToDo.ref as RefObject<HTMLInputElement>}
				required={whatToDo.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
			/>

			{/* Question 2 */}
			<RadioInput
				name={requestAs.name}
				label={requestAs.label}
				value={requestAs.value}
				list={radioListRequestAs}
				direction={Direction.vertical}
				hasError={errors!.includes(requestAs.name)}
				onChange={(value: string) => updateInput(requestAs.name, value)}
				ref={requestAs.ref as RefObject<HTMLInputElement>}
				required={requestAs.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
			/>

			{requestAs.value == REQUEST_CONFIGS_KEYS.requestAs.entreprise && (
				<>
					{/* Question 2.1 */}
					<TextInput
						id={companyName.name}
						label={companyName.label}
						value={companyName.value}
						onChange={(value: string) => updateInput(companyName.name, value)}
						hasError={errors?.includes(companyName.name)}
						required={companyName.required}
						ref={companyName.ref as RefObject<HTMLInputElement>}
						maxCharacters={100}
						isSummaryStep={isSummaryStep}
					/>

					{/* Question 2.2 */}
					<TextInput
						id={representativeName.name}
						label={representativeName.label}
						value={representativeName.value}
						onChange={(value: string) =>
							updateInput(representativeName.name, value)
						}
						hasError={errors?.includes(representativeName.name)}
						required={representativeName.required}
						ref={representativeName.ref as RefObject<HTMLInputElement>}
						maxCharacters={100}
						isSummaryStep={isSummaryStep}
					/>
				</>
			)}

			<>
				{/* Question 3 */}
				{whatToDo.value !==
					REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_4BoatDock && (
					<>
						{/* Architectural implementation and integration plan (PIIA) */}
						<h5 className={pageUtils.classes.h5}>
							{
								pageAssets?.request_form_buildingConstructionOrAdditionPermit_piia_title
							}
						</h5>

						<RadioInput
							name={isSubjectToPiiaApproval.name}
							label={isSubjectToPiiaApproval.label}
							value={isSubjectToPiiaApproval.value}
							list={radioListYesNo}
							direction={Direction.vertical}
							hasError={errors!.includes(isSubjectToPiiaApproval.name)}
							onChange={(value) =>
								updateInput(isSubjectToPiiaApproval.name, value)
							}
							ref={isSubjectToPiiaApproval.ref as RefObject<HTMLInputElement>}
							required={isSubjectToPiiaApproval.required}
							hasBackgroundWrapper={true}
							classWrapper={classes.reducedMarginBottom}
							description={
								pageAssets?.request_form_buildingConstructionOrAdditionPermit_isSubjectToPiiaApproval_description
							}
							isSummaryStep={isSummaryStep}
						/>

						{isSubjectToPiiaApproval.value == radioListYesNo[0].value && (
							<>
								{/* Question 4 */}
								<RadioInput
									name={hasBeenSubjectToApproval.name}
									label={hasBeenSubjectToApproval.label}
									value={hasBeenSubjectToApproval.value}
									list={radioListYesNo}
									direction={Direction.vertical}
									hasError={errors!.includes(hasBeenSubjectToApproval.name)}
									onChange={(value) =>
										updateInput(hasBeenSubjectToApproval.name, value)
									}
									ref={
										hasBeenSubjectToApproval.ref as RefObject<HTMLInputElement>
									}
									required={hasBeenSubjectToApproval.required}
									hasBackgroundWrapper={true}
									classWrapper={classes.reducedMarginBottom}
									isSummaryStep={isSummaryStep}
								/>
								{hasBeenSubjectToApproval.value == radioListYesNo[0].value && (
									<>
										<MaskedTextInput
											id={iaNumber.name}
											label={iaNumber.label}
											value={iaNumber.value}
											onChange={(value) => {
												const formattedValue = value.toLocaleUpperCase()
												const finalValue =
													formattedValue === '' ? '' : `IA-${formattedValue}`

												updateInput(iaNumber.name, finalValue)
											}}
											hasError={errors.includes(iaNumber.name)}
											required={iaNumber.required}
											ref={iaNumber.ref as RefObject<HTMLInputElement>}
											max={9}
											min={9}
											mask="0000-0000"
											placeholder="AAAA-XXXX"
											prefix="IA-"
											errors={errors}
											setError={onFixError}
											schema={/^IA-\d{4}-\d{4}$/}
											isSummaryStep={isSummaryStep}
										/>

										<MaskedTextInput
											id={ecResolutionNumber.name}
											label={ecResolutionNumber.label}
											value={ecResolutionNumber.value}
											onChange={(value) => {
												const formattedValue = value.toLocaleUpperCase()
												const finalValue =
													formattedValue === '' ? '' : `CE-${formattedValue}`

												updateInput(ecResolutionNumber.name, finalValue)
											}}
											hasError={errors.includes(ecResolutionNumber.name)}
											required={ecResolutionNumber.required}
											ref={
												ecResolutionNumber.ref as RefObject<HTMLInputElement>
											}
											max={13}
											min={13}
											mask="00000000-0000"
											placeholder="AAAAMMJJ-XXXX"
											prefix="CE-"
											errors={errors}
											setError={onFixError}
											schema={/^CE-\d{8}-\d{4}$/}
											isSummaryStep={isSummaryStep}
										/>
									</>
								)}
							</>
						)}
					</>
				)}
			</>
		</>
	)
}

export default Step1TypeDeDemande
